/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeightUpsertRequestDto
 */
export interface HeightUpsertRequestDto {
    /**
     * Height value
     * @type {number}
     * @memberof HeightUpsertRequestDto
     */
    value: number;
    /**
     * Height unit
     * @type {string}
     * @memberof HeightUpsertRequestDto
     */
    unit: HeightUpsertRequestDtoUnitEnum;
}


/**
 * @export
 */
export const HeightUpsertRequestDtoUnitEnum = {
    Cm: 'cm',
    In: 'in'
} as const;
export type HeightUpsertRequestDtoUnitEnum = typeof HeightUpsertRequestDtoUnitEnum[keyof typeof HeightUpsertRequestDtoUnitEnum];


/**
 * Check if a given object implements the HeightUpsertRequestDto interface.
 */
export function instanceOfHeightUpsertRequestDto(value: object): value is HeightUpsertRequestDto {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    return true;
}

export function HeightUpsertRequestDtoFromJSON(json: any): HeightUpsertRequestDto {
    return HeightUpsertRequestDtoFromJSONTyped(json, false);
}

export function HeightUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeightUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'unit': json['unit'],
    };
}

export function HeightUpsertRequestDtoToJSON(json: any): HeightUpsertRequestDto {
    return HeightUpsertRequestDtoToJSONTyped(json, false);
}

export function HeightUpsertRequestDtoToJSONTyped(value?: HeightUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'unit': value['unit'],
    };
}

